import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import { AI_ALERTS_TITLE, AI_ALERT_DATE_SHORTCUTS } from '@utils/aiAlerts/mapping';
import { intervalSelector } from '@store/aiAlerts/base/selectors';
import { featureSelector } from '@store/common/selectors';
import { setInterval } from '@store/aiAlerts/base/actions';
import { setSearchKey } from '@store/aiAlerts/summary/actions';
import DatePickerV2 from '@components/common/date-picker-v2';
import { searchKeySelector } from '@store/aiAlerts/summary/selectors';
import {
  Title,
  HeaderWrapper,
  LeftWrapper,
  RightWrapper,
  DateWrapper,
  SearchWrapper,
  StyledButton,
} from './styled';
import KebabDropdown from './kebabDropDown';
import Insights from './Insights';
import DimensionScan from './DimensionScanBtn';
import SensitivityPopup from '../../sensitivityControl/popup';
import SensitivityDrawer from '../../sensitivityControl';
import { SettingOutlined } from '@ant-design/icons';

const Header = () => {
  const selectedInterval = useSelector(intervalSelector);
  const dispatch = useDispatch();
  const searchKey = useSelector(searchKeySelector);
  const [isPopupOpen, setPopup] = useState(false);
  const isAlertPartnerAccount = useSelector(featureSelector('is_alert_forwarding_partner'));

  const setSearchString = debounce((searchString) => {
    dispatch(setSearchKey(searchString));
  }, 250);

  const handleSearch = (e) => {
    const searchString = e.target.value;
    setSearchString(searchString);
  };

  // reset search string on unmount
  useEffect(
    () => () => {
      dispatch(setSearchKey(''));
    },
    [dispatch],
  );

  const openSensitivityModal = () => {
    setPopup(true);
  };
  const cancelEdit = () => setPopup(!isPopupOpen);

  const getSensitivityPopup = () => {
    if (!isAlertPartnerAccount) {
      return (
        <>
          <Button onClick={openSensitivityModal} icon={<SettingOutlined />}>
            Alert Config
          </Button>

          {/*<SensitivityPopup isPopupOpen={isPopupOpen} cancelEdit={cancelEdit} />*/}
          <SensitivityDrawer isPopupOpen={isPopupOpen} cancelEdit={cancelEdit} />
        </>
      );
    }

    return null;
  };

  return (
    <HeaderWrapper>
      <LeftWrapper>
        <Title> {AI_ALERTS_TITLE} </Title>
        <SearchWrapper>
          <Input
            type="text"
            placeholder="Search by alertId, metric, root cause, status or peak severity"
            onChange={handleSearch}
            style={{ width: '100%' }}
            defaultValue={searchKey}
          />
        </SearchWrapper>
        <DimensionScan />
      </LeftWrapper>
      <RightWrapper>
        <Insights />
        {getSensitivityPopup()}
        <DateWrapper>
          <DatePickerV2
            selectedInterval={selectedInterval}
            shortcuts={AI_ALERT_DATE_SHORTCUTS}
            cutoffDate={null}
            setInterval={setInterval}
          />
        </DateWrapper>
        <DateWrapper>
          <KebabDropdown />
        </DateWrapper>
      </RightWrapper>
    </HeaderWrapper>
  );
};

export default Header;
